import { Pipe, PipeTransform } from '@angular/core';
import { EsriUtils, QueryableLayer, SublayerTypes } from '../utils/esri.utils';

type LayerLike = QueryableLayer | SublayerTypes;

@Pipe({
  name: 'fieldFormat',
})
export class FieldFormatPipe implements PipeTransform {
  private fieldKey:
    | __esri.Field
    | __esri.FieldInfo
    | __esri.FieldInfoFormat
    | string;
  private fieldFormatter: (value) => any;

  transform(
    value: any,
    field: __esri.Field | __esri.FieldInfo | __esri.FieldInfoFormat | string,
    layerOrLayers?: LayerLike | LayerLike[]
  ) {
    if (this.fieldKey !== field) {
      this.fieldKey = field;

      this.fieldFormatter = EsriUtils.buildFormatter(field, layerOrLayers);
    }

    if (this.fieldFormatter) {
      value = this.fieldFormatter(value);
    }

    if (value === null) {
      return 'Null';
    }

    return value;
  }
}
